const time = {
  en: {
    'time.title': 'Time Tracking',
    'time.subtitle': 'Track your time and manage entries',
    'time.currentTimer': 'Current Timer',
    'time.startedAt': 'Started at',
    'time.noActiveTimer': 'No active timer',
    'time.startTimer': 'Start Timer',
    'time.stopTimer': 'Stop Timer',
    'time.addEntry': 'Add Entry',
    'time.updateEntry': 'Update Entry',
    'time.export': 'Export',

    'time.filters': 'Filters',
    'time.startDate': 'Start Date',
    'time.endDate': 'End Date',
    'time.project': 'Project',
    'time.client': 'Client',
    'time.allProjects': 'All Projects',
    'time.allClients': 'All Clients',
    'time.includeArchived': 'Include archived',

    'time.timeEntries': 'Time Entries',
    'time.date': 'Date',
    'time.task': 'Tasks',
    'time.duration': 'Duration',
    'time.actions': 'Actions',

    'time.addTimeEntry': 'Add Time Entry',
    'time.editTimeEntry': 'Edit Time Entry',
    'time.taskDescription': 'Task Description',
    'time.startTime': 'Start Time',
    'time.endTime': 'End Time',
    'time.selectProject': 'Select a project',
    'time.cancel': 'Cancel',

    'time.validationProjectRequired': 'Project is required',
    'time.validationDescriptionRequired': 'Description is required',
    'time.validationStartTimeRequired': 'Start time is required',
    'time.validationEndTimeRequired': 'End time is required',
    'time.runningEntryEndHint': 'This timer is still running. Leave the end time empty to keep it running.',
    'time.modifyDescription': 'Modify description',
    'time.saveDescription': 'Save',
    'time.noDescription': 'No description yet',

    'time.confirmDelete': 'Are you sure you want to delete this time entry?',
    'time.loadError': 'Failed to load time entries',

    'time.toastTimerStopped': 'Timer stopped successfully',
    'time.toastStopTimerFailed': 'Failed to stop timer',
    'time.toastEntryAdded': 'Time entry added successfully',
    'time.toastAddFailed': 'Failed to add time entry',
    'time.toastEntryUpdated': 'Time entry updated successfully',
    'time.toastUpdateFailed': 'Failed to update time entry',
    'time.toastEntryDeleted': 'Time entry deleted successfully',
    'time.toastDeleteFailed': 'Failed to delete time entry',

    'time.timerStarted': 'Timer started',
    'time.startTimerFailed': 'Failed to start timer',
    'time.startTimerModalTitle': 'Start Timer',
    'time.startTimerProject': 'Project',
    'time.startTimerDescription': 'Description (optional)',
    'time.startTimerConfirm': 'Start Timer',
    'time.noProjects': 'No projects available to track time.',
  },

  es: {
    'time.title': 'Control de tiempo',
    'time.subtitle': 'Registra tu tiempo y administra las entradas',
    'time.currentTimer': 'Temporizador actual',
    'time.startedAt': 'Iniciado a las',
    'time.noActiveTimer': 'No hay temporizador activo',
    'time.startTimer': 'Iniciar temporizador',
    'time.stopTimer': 'Detener temporizador',
    'time.addEntry': 'Agregar entrada',
    'time.updateEntry': 'Actualizar entrada',
    'time.export': 'Exportar',

    'time.filters': 'Filtros',
    'time.startDate': 'Fecha de inicio',
    'time.endDate': 'Fecha de fin',
    'time.project': 'Proyecto',
    'time.client': 'Cliente',
    'time.allProjects': 'Todos los proyectos',
    'time.allClients': 'Todos los clientes',
    'time.includeArchived': 'Incluir archivados',

    'time.timeEntries': 'Entradas de tiempo',
    'time.date': 'Fecha',
    'time.task': 'Tareas',
    'time.duration': 'Duración',
    'time.actions': 'Acciones',

    'time.addTimeEntry': 'Agregar entrada de tiempo',
    'time.editTimeEntry': 'Editar entrada de tiempo',
    'time.taskDescription': 'Descripción de la tarea',
    'time.startTime': 'Hora de inicio',
    'time.endTime': 'Hora de fin',
    'time.selectProject': 'Selecciona un proyecto',
    'time.cancel': 'Cancelar',

    'time.validationProjectRequired': 'El proyecto es obligatorio',
    'time.validationDescriptionRequired': 'La descripción es obligatoria',
    'time.validationStartTimeRequired': 'La hora de inicio es obligatoria',
    'time.validationEndTimeRequired': 'La hora de fin es obligatoria',
    'time.runningEntryEndHint': 'Este temporizador sigue activo. Deja la hora de fin vacía para mantenerlo en marcha.',
    'time.modifyDescription': 'Modificar descripción',
    'time.saveDescription': 'Guardar',
    'time.noDescription': 'Aún no hay descripción',

    'time.confirmDelete': '¿Estás seguro de que deseas eliminar esta entrada de tiempo?',
    'time.loadError': 'No se pudieron cargar las entradas de tiempo',

    'time.toastTimerStopped': 'Temporizador detenido correctamente',
    'time.toastStopTimerFailed': 'No se pudo detener el temporizador',
    'time.toastEntryAdded': 'Entrada de tiempo agregada correctamente',
    'time.toastAddFailed': 'No se pudo agregar la entrada de tiempo',
    'time.toastEntryUpdated': 'Entrada de tiempo actualizada correctamente',
    'time.toastUpdateFailed': 'No se pudo actualizar la entrada de tiempo',
    'time.toastEntryDeleted': 'Entrada de tiempo eliminada correctamente',
    'time.toastDeleteFailed': 'No se pudo eliminar la entrada de tiempo',

    'time.timerStarted': 'Temporizador iniciado',
    'time.startTimerFailed': 'No se pudo iniciar el temporizador',
    'time.startTimerModalTitle': 'Iniciar temporizador',
    'time.startTimerProject': 'Proyecto',
    'time.startTimerDescription': 'Descripción (opcional)',
    'time.startTimerConfirm': 'Iniciar temporizador',
    'time.noProjects': 'No hay proyectos disponibles para registrar tiempo.',
  },
};

export default time;
